import * as React from 'react';
import ContainerCore from '@core-front/container';
function BEM(props) {
    const classArray = [''];
    if (props.maxWidth) {
        classArray.push(`container--max-width-${props.maxWidth}`);
    }
    if (props.className) {
        classArray.push(props.className);
    }
    return classArray.join(' ');
}
const Container = (props) => {
    return (React.createElement(ContainerCore, Object.assign({}, props, { className: BEM(props) }), props.children));
};
export { Container as default, };
